<template>
    <div class="Product">
        <menuBox :step="5"></menuBox>
        <div class="banner-box" id="home" ref="home">
            <div class="banner-text">
                <div class="title">ลบข้อมูล</div>
            </div>
        </div>
        <div class="del-data-box" id="deletdata" ref="deletdata">
            <div class="tel-box" v-if="steps == 1">
                <div class="tip">การใช้ฟังก์ชันการลบข้อมูลเพื่อความปลอดภัยของข้อมูลของคุณ คุณต้องยืนยันตัวตนของคุณ</div>
                <div class="title">กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ</div>
                <input v-model="mobile" type="text" class="tel-in" placeholder="กรุณากรอกหมายเลขโทรศัพท์">
                <input v-model="password" type="password" class="tel-pa" placeholder="กรุณากรอกรหัสผ่านสำหรับแอป">
                <div class="btn" @click="delSearch">ขั้นตอนถัดไป</div>
            </div>
            <div class="tel-box" v-else-if="steps == 2">
                <div class="กล่องข้อความ">
                    เรียนผู้ใช้
                    <br> สวัสดี! ขอบคุณมากครับที่เลือกใช้แอพ
                    <br> ก่อนที่จะสมัครลบบัญชี โปรดตรวจสอบให้แน่ใจว่าคำสั่งซื้อของคุณทั้งหมดได้รับการชำระแล้ว และไม่มีคำสั่งซื้อที่อยู่ระหว่างการตรวจสอบ โปรดทราบว่าเมื่อลบบัญชีแล้ว จะไม่สามารถกู้คืนข้อมูลได้ โปรดยืนยันอย่างรอบคอบก่อนใช้งาน แอพนี้ไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดขึ้นต่อทรัพย์สินส่วนบุคคล
                    <br> หากคุณยืนยันว่าต้องการลบข้อมูลของคุณ โปรดคลิกปุ่มด้านล่าง
                </div>
                <div class="btn" @click="candelete">ยืนยันการลบ</div>
            </div>

            <div class="tel-box" v-else-if="steps == 3">
                <div class="title">โปรดป้อนรหัสยืนยันเพื่อยืนยันตัวตนของคุณ</div>
                <div class="iump-box">
                    <input v-model="code" type="text" class="car-in tel-in" placeholder="กรุณากรอกรหัสยืนยัน 4 หลัก" />
                    <div class="count-btn" @click="Reenviar"> {{ 0 >= Time ? 'ส่งอีกครั้ง' : Time }} </div>
                </div>
                <div class="btn" @click="doDelete">ตกลง</div>
            </div>

            <div class="tel-box del-box" v-else-if="steps == 4">
                <img src="../assets/del.png" alt="">
                <p>ข้อมูลของคุณถูกลบแล้ว!</p>
            </div>
            <div class="tel-box" v-else-if="steps == 5">
                <div class="title">การยืนยันบัตรประจำตัวประชาชน</div>
                <input v-model="idcard" type="text" class="tel-in" placeholder="กรุณากรอกบัตรประจำตัวประชาชนของคุณ">
                <div class="btn" @click="verifyIdCard">กำลังตรวจสอบ</div>
            </div>
        </div>
        <footerBox></footerBox>

        <div class="flex-box-item" v-if="msgDlg">
            <div class="msg-box">
                <div class="msg">
                    <img src="../assets/title-err.png" class="err-img">
                    {{ msg }}
                </div>
                <img src="../assets/close.png" class="close" @click="msgDlg = false">
            </div>
        </div>
    </div>
</template>
<script>
import * as api from "@/api/api";
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            showMenu: false,
            mobile: '',
            password: '',
            code: '',
            msgDlg: false,
            msg: '',
            steps: 1,
            infoData: {},
            Time: 0,
            idcard: '',
            verifyIDCard: '',
        }
    },
    mounted() {

    },
    methods: {
        delSearch() {
            let data = {
                mobile: this.mobile,
                password: this.password
            }
            if (!this.mobile) {
                this.msg = 'หมายเลขโทรศัพท์มือถือต้องไม่เว้นว่าง'
                this.msgDlg = true
                return
            }
            if (!this.password) {
                this.msg = 'รหัสผ่านต้องไม่เว้นว่าง'
                this.msgDlg = true
                return
            }

            let loding = this.$loading.show({})
            api.delInfoSearch(data).then(res => {
                loding.hide()
                this.infoData = res.data
                this.steps = 2
            }).catch(e => {
                loding.hide()
                this.msg = e.message
                this.msgDlg = true
            })
        },
        candelete() {
            let data = {
                user_id: this.infoData.user_id
            }
            let loding = this.$loading.show({})
            api.delInfoCanDelete(data).then(res => {
                loding.hide()
                if (res.data.idcard) {
                    this.verifyIDCard = res.data.idcard
                    this.steps = 5
                } else {
                    this.steps = 3
                    this.Reenviar()
                }
            }).catch(e => {
                loding.hide()
                this.msgDlg = true
                this.msg = e.message
            })
        },
        verifyIdCard() {
            console.log(this.verifyIDCard);
            if (this.verifyIDCard == this.idcard) {
                this.steps = 3
                this.Reenviar()
            } else {
                this.msgDlg = true
                this.msg = 'ป้อนบัตรประจำตัวไม่ถูกต้องและการตรวจสอบล้มเหลว'
            }
        },
        Reenviar() {
            if (this.Time > 0) {
                return
            }
            this.Countdown(60)
            let data = {
                mobile: this.mobile
            }
            let loding = this.$loading.show({})
            api.delInfoSms(data).then(res => {
                loding.hide()
            }).catch(e => {
                loding.hide()
                this.msgDlg = true
                this.msg = e.message
            })
        },
        doDelete() {
            if (!this.code) {
                this.msg = 'ต้องกรอกรหัสยืนยัน'
                this.msgDlg = true
                return
            }
            let loding = this.$loading.show({})
            let data = {
                mobile: this.mobile,
                code: this.code,
                user_id: this.infoData.user_id
            }
            api.delInfoDoDelete(data).then(res => {
                loding.hide()
                this.steps = 4
            }).catch(e => {
                loding.hide()
                this.msgDlg = true
                this.msg = e.message
            })
        },
        Countdown(time) {
            this.Time = time
            if (time <= 0) {
                return
            }

            setTimeout(() => {
                this.Countdown(time - 1)
            }, 1000);
        }
    }
}
</script>
<style lang="less" scoped>
.banner-box {
    background-image: url(../assets/swiper-4.png);
    height: 500px;
    background-size: 100% 100%;
    margin-top: -60px;
    text-align: center;

    .banner-text {
        margin: 0 360px;
        padding-top: 165px;

        .title {
            font-family: Roboto, Roboto;
            font-weight: bold;
            font-size: 72px;
            color: #ffffff;
            margin-top: 100px;
        }

        .text {
            font-family: Roboto, Roboto;
            font-weight: 400;
            font-size: 26px;
            color: #ffffff;
            margin-top: 20px;
        }
    }
}

.title {
    font-weight: bold;
    font-size: 46px;
    color: #333333;
    text-align: center;
}

.sbtitle {
    font-weight: 500;
    font-size: 24px;
    color: #00387A;
    margin-bottom: 20px;
    text-align: center;
}

.service-title {
    height: 700px;
    background: url(../assets/about-1.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    div {
        font-weight: 900;
        font-size: 72px;
        color: #FFFFFF;
    }

    p {
        font-size: 20px;
        color: #FFFFFF;
        margin-top: 20px;
    }
}

.delete-box {
    padding: 170px 360px;
    background: #F5F5F5;
    display: flex;
    align-items: center;
    justify-content: center;
}

.del-data-box {
    background: #F5F5F5;
    padding: 100px 560px 240px 560px;

    .tel-box {
        min-height: 155px;
        background: #FFFFFF;
        padding: 40px 150px;
        display: flex;
        flex-direction: column;
        align-items: self-start;

        .tip {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
        }

        .title {
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            margin-top: 24px;
        }

        .tel-in,
        .tel-pa {
            width: 452px;
            height: 60px;
            border-radius: 5px;
            border: 1px solid #EFEFEF;
            margin-top: 14px;
            padding: 0px 24px;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 60px;
        }

        .iump-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 24px;
            width: 500px;
        }

        .car-in {
            width: 302px;
            margin: 0;
        }

        .btn {
            width: 452px;
            height: 60px;
            padding: 0px 24px;
            background: #00387A;
            border-radius: 5px;
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            line-height: 60px;
            margin-top: 24px;
            cursor: pointer;
        }

        .count-btn {
            width: 120px;
            height: 60px;
            border-radius: 8px;
            border: 1px solid #EFEFEF;
            line-height: 60px;
            font-size: 16px;
            font-weight: 400;
            color: #00387A;
            text-align: center;
            cursor: pointer;
        }

        .text-box {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
        }
    }

    .del-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        img {
            width: 97px;
        }

        p {
            font-size: 16px;
            font-weight: 400;
            margin-top: 24px;
        }
    }
}

.flex-box-item {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: fade(#000, 90%);
    display: flex;
    align-items: center;
    justify-content: center;

    .msg-box {
        position: relative;

        .err-img {
            width: 100px;
            margin-top: -100px;
        }

        .msg {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background: #fff;
            text-align: center;
            color: #999;
            font-size: 26px;
            padding: 50px;
            width: 380px;
            border-radius: 17px;

        }

        .close {
            position: absolute;
            right: 10px;
            top: 10px;
            width: 30px;
        }
    }
}
</style>
